import { stepTypeInts, getPercent } from "@/utils/general";
import config from "@/components/statistics/stats/tabs/generalCirclesConfig";

export const generalCountConfig = {
  type: 'number',
  sortable: true,
  total: "reduce"
}

export class StatTableConfig {
  // type, counts, charts
  constructor(data) {
    const { type, counts, charts } = data;
    this.type = stepTypeInts[type];
    this.counts = counts;
    this.charts = charts;

    this.columns = {
      Name: {
        label: 'Акция',
        sortable: true,
        total: 'Итого:'
      },
      membersCount: {
        label: 'Участники',
        ...generalCountConfig
      },
      ...counts
    };

    this.childrenColumns = {
      SegmentName: {
        label: "Название сегмента"
      },
      SegmentID: {
        label: "ID сегмента"
      },
      ...counts
    };
  }

  getPiePercantageData(data, key) {
    return data[this.type] ? data[this.type][key] : {};
  }

  generateAdditionalFields(i) {
    const { MsgStats, Count } = i.Stats;
    const fields = Object.keys(this.counts);
    const statInfo = MsgStats[this.type];

    fields.forEach(f => {
      if (!statInfo) {
        i[f] = 0;
      } else {
        if (f === "undelivered") {
          // complete data from backend with undelivered info
          statInfo[f] = { Count: statInfo.sent.Count - statInfo.delivered.Count };
        }

        if (f === "openedTotal") {
          statInfo[f] =  { Count: statInfo.opened.Total };
        }

        if (f === "clickedTotal") {
          statInfo[f] =  { Count: statInfo.clicked.Total };
        }

        if (config[f]) {
          const totalKey = config[f].totalKey;
          const total = totalKey && (statInfo[totalKey].Count || statInfo[totalKey].Count === 0) ? statInfo[totalKey].Count : Count;
          statInfo[f].Percent = getPercent(total, statInfo[f].Count);
        }

        i[f] = statInfo[f].Count;
      }
    });
  }

  formChildren(segments, promotionID) {
    segments.forEach((i, index) => {
      i.ID = promotionID + index;
      i.Index = index;
      i.membersCount = i.Stats.ContactsCount;

      this.generateAdditionalFields(i);
    });
    return segments;
  }
}
